import React from 'react';

const WaterRemover = () => {
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', lineHeight: '1.6', color: '#333', padding: '20px' }}>
      <h1 style={{ color: '#0056b3' }}>Privacy Policy</h1>
      <p>Effective Date: 04/10/2024</p>

      <p>
        Welcome to Speaker Cleaner. Your privacy is important to us. This Privacy Policy explains how we collect, use,
        and share information about you when you use our app, Speaker Cleaner. By using the app, you agree to the
        collection and use of information in accordance with this policy.
      </p>

      <h2 style={{ color: '#0056b3' }}>1. Information We Collect</h2>
      <p>We may collect the following types of information:</p>
      <ul>
        <li>
          <strong>Personal Information:</strong> We do not collect any personal information such as name, email address,
          or contact details.
        </li>
        <li>
          <strong>Usage Data:</strong> We may collect anonymous data regarding how the app is used, such as features
          accessed, the frequency of use, and other app interactions to improve our services.
        </li>
      </ul>

      <h2 style={{ color: '#0056b3' }}>2. How We Use Your Information</h2>
      <p>
        The information we collect is used to enhance the app's functionality and provide a better user experience. We do
        not use personal information for marketing purposes or share it with third parties.
      </p>

      <h2 style={{ color: '#0056b3' }}>3. Data Security</h2>
      <p>
        We are committed to protecting your data and have implemented reasonable security measures to safeguard the
        information we collect. However, please note that no method of electronic transmission or storage is 100% secure.
      </p>

      <h2 style={{ color: '#0056b3' }}>4. Changes to This Privacy Policy</h2>
      <p>
        We may update our Privacy Policy from time to time. Any changes will be posted on this page, and you are advised
        to review this page periodically for any updates. Your continued use of the app following any changes signifies
        your acceptance of the revised Privacy Policy.
      </p>

      <h2 style={{ color: '#0056b3' }}>5. Contact Us</h2>
      <p>If you have any questions or concerns about this Privacy Policy or our data practices, please contact us at:</p>
      <p>Email: allnotesunderoneroof@gmail.com</p>

      <footer>
        <p>&copy; [Year] Speaker Cleaner. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default WaterRemover;
